module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "default",
    attrs: {
      "id": "d8e151NaN"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e985"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_toc_r1#d6e2",
      "id": "d7e2"
    }
  }, [_vm._v("Chapter 1 ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1035"
    }
  }, [_vm._v("The cold, tiled floor came at me fast. I closed my eyes, landing safely on my forearms. The shock had stung my hands a bit, but otherwise I was fine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e1215"
    }
  }, [_vm._v("“Stay away! You don’t belong here anyway,” Ana snapped at me as I stood. She shoved me again, then disappeared down the hallway, her posse following and giggling as they trailed behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e1335"
    }
  }, [_vm._v("Just another typical morning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e1385"
    }
  }, [_vm._v("I sighed, shaking off the fall. Students flashed repulsive looks my way. One kid actually tugged my hair as he walked past. That hadn’t happened since sixth grade.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e1505"
    }
  }, [_vm._v("Ana and I had been friends once when we were twelve. I had just started at Tamizeh’s Interdisciplinary High School. Everyone noticed my differences, but she hadn’t cared . . . at first. In hindsight, perhaps she had simply wanted to be my friend because I could help her with her schoolwork. But as students started isolating and taunting me, she began to side with them. She was always one to follow the crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e1715"
    }
  }, [_vm._v("Tamizeh consisted of five million four hundred thousand nine hundred twenty-one brunettes with blue eyes. I was the only person in Tamizeh who had jet-black hair and electric, violet eyes. The outsider. The freak.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e1865"
    }
  }, [_vm._v("“Hey, Alexia,” Lyli, my only friend, said. Her long, chocolate  brown hair shimmered under the fluorescent lights. She bent down and started to pick up my belongings that were scattered across the hallway. I knelt down and carefully placed my papers into my bag.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e2056"
    }
  }, [_vm._v("“Math test second period, right?” Lyli smiled as we stood. I nodded. “Worried about it?” I shook my head. “Did you study?” I shook my head again. “I wish I could do that and still get your grades.” She smiled again, and we started to walk to class.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e2226"
    }
  }, [_vm._v("As we walked through the halls, I felt all eyes on me. Every student had brown hair and blue eyes. I stood out like a sore thumb. They were all the same.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e2346"
    }
  }, [_vm._v("Except me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e2396"
    }
  }, [_vm._v("At first I hated the color of my hair and eyes, but in reality, I kind of liked being on my own. Everyone was incredibly annoying, with their blank stares and robotic gestures. They were so fake. Although I hopelessly wanted to fit in, I wasn’t sure if I wanted to be a part of that group. I just wanted to be accepted, even with my black, silk hair and purple irises. After years and years of ridicule and teasing, I grew to love my differences.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e2646"
    }
  }, [_vm._v("Girls swayed their hips as they hurried down the corridor with their hair flapping behind them, while the boys dragged one foot behind the other. Their gazes were blank, emotionless, with straight glares frozen on specific thoughts. I couldn’t stand high school, the teachers, or the students.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e2826"
    }
  }, [_vm._v("They were like robots, lifeless.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e2876"
    }
  }, [_vm._v("“I’ll see you after school. Good luck with your test,” Lyli said, then she took off down the hallway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e2966"
    }
  }, [_vm._v("As I headed toward my class, I passed a large hologram of Matthew, Tamizeh’s Community leader. He was standing majestically, like a strong, sturdy, powerful horse. He looked extremely uncomfortable, with his chest pretentiously pushed out and his head tilted upward, as  if gazing intently into the infinity above. His lips were slightly parted, ready to speak, and his dark hair was slicked back. There were other holograms of him sprinkled around the school. For a leader, he looked rather pathetic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e3287"
    }
  }, [_vm._v("I passed a row of guns that were neatly displayed at the end of the wall. They were there in case of emergencies, but I had never actually used them. We had been taught to shoot and handle firearms, but I’d never had the opportunity to take them off the wall and pull the trigger, although with Ana around, it was tempting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e3477"
    }
  }, [_vm._v("As I slipped through the door, my history professor’s stern voice shouted, “Late again, Alexia! Do you have an excuse this time?” Mr. Ondo kept his icy stare glued to me while I gently closed the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e3587"
    }
  }, [_vm._v("“No, sir,” I responded with diverted eyes, then found my desk in the far left corner of the classroom. Ana’s foot stuck out when I walked past her, but I stepped over it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e3707"
    }
  }, [_vm._v("I sat down and took out my palette, which had my books, documents, projects, music, and some games on it. Because it was touch screen, fingerprints lined the top layer, which always drove me insane, so I wiped them off with the sleeve of my shirt. The palette screen’s bright, white light shone into my eyes as I logged into the class account. While I started reading the newest article on the site, Mr. Ondo started his lecture on the Long War, as usual.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e3947"
    }
  }, [_vm._v("“A long time ago, the world’s resources were almost completely wasted, and chaos had taken over the planet as every country fought for what was left of this world. As the Third World War continued, the countries dissipated and were renamed communities. Tamizeh became a very powerful Community, sustaining herself and claiming resources. Matthew’s ancestors protected us and led us to a better world. But while we were striving, other communities were struggling to survive and joined forces against us. Matthew decided that we should establish  a more structural community and perhaps in the future become a nation or a country. This fight is the one we continue today, the Long War. So, Amelia, when did Matthew . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e4368"
    }
  }, [_vm._v("I zoned out, having the entire history of Tamizeh already engraved in my mind, hearing it every day for as long as I could remember. But I had a different interpretation of the Long War.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e4488"
    }
  }, [_vm._v("The War had been going on for over two centuries. Maybe Tamizeh had really started off trying to fight for land and necessities, but there must have been more to it than just survival; otherwise, why would we still be destroying other communities? The world had been overpopulated and practically exterminated, devastated by our leader’s command. All that was left was our Community, forests, and small, insignificant villages that had less technology than us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e4728"
    }
  }, [_vm._v("Once Matthew had taken his father’s place in leading Tamizeh, he had decided that surviving the War wasn’t enough. Through unjustified crusades, he started taking over small villages around us, then expanded his reign. There were a couple of small, international communities, but Tamizeh was the capital. Matthew had protected us and driven us to the top of the food chain, but that came with a price . . . endless war and continuous bloodshed. Tamizeh had become the enemy of all other communities, entangled in a massive world war. What bothered me the most was that we never learned why the other communities were our nemeses. They didn’t teach us that in school. Matthew was a spineless dictator who only seemed consumed with power and greed, not the loss of innocent lives. We had to follow his unjust laws, and I silently hated him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e5168"
    }
  }, [_vm._v("“Alexia, what was Matthew’s most glorious battle?” Mr. Ondo snapped me back to reality.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e5258"
    }
  }, [_vm._v("I shifted in my chair. “The Battle of Seven. It began on January 21 and ended seven days later. That was his first winning battle, which accumulated over seven thousand deaths, obliterated six communities,  and rendered one to nothing more than a small city, now known as Maria, after her leader, Maria, died during that battle. The exact location of Maria is unknown, but we have a general understanding of where it is. The Battle of Seven is considered the most glorious, because Matthew managed to lose only five soldiers. The other communities were barely left with any survivors, as no prisoners were taken and most were shot on sight.” I purposely ended with an implied accusation of Matthew’s immorality, but no one caught on. Instead, the professor nodded and continued describing what had happened during that battle, how Matthew had protected Tamizeh from six communities. Sure, it was impressive, but I didn’t see why six civilizations were destroyed. I gazed out the window, dreaming until the bell rang.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e5799"
    }
  }, [_vm._v("I sat at an empty table in the cafeteria and started picking at my bland pasta and squished meatballs. Every day, we were reminded of Matthew’s strenuous efforts to protect us from the Long War, but we didn’t seem war-torn. In fact, the Community had a surplus of food, electricity, running water, advanced science, etc. We almost never spoke of the War outside of history class, because no one felt affected by it. Only the soldiers, who were mysteriously harvested, were touched by the fighting, and they were never seen or heard of again. It was almost as if they had never even existed. They would disappear in their early twenties, as expected. That explained why children, teenagers, young adults, and citizens over fifty populated Tamizeh; the other generations were busy reloading guns to empty on other lives.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e6199"
    }
  }, [_vm._v("I saw Lyli eating with her large group of friends across the cafeteria. She was laughing with all her heart, her silk, brown hair dancing around her neck as she tilted her head back, but her eyes didn’t match her emotions. They were blank mirrors, simply reflecting the environment around her. She flashed me a quick smile and returned to her conversation with her friends.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e6419"
    }
  }, [_vm._v("I went to my locker to charge my palette before my next class. “Freak”  was scribbled across my locker in red paint. I sighed. My locker was always being vandalized. I was used to it: the teasing, the hair pulling, the pushing and shoving, the name calling, the vandalizing . . . it never seemed to end. I didn’t want to be used to it, but it was inevitable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e66310"
    }
  }, [_vm._v("“Auditorium in five minutes,” the voice over the speaker blared. I headed toward the auditorium, merging into the crowd, as if I could fit in with my black hair in a sea of brunettes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e67510"
    }
  }, [_vm._v("I sat in the far back, avoiding anyone’s attention. One student roughly pushed passed me, so I pulled my chair back and kept quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e68410"
    }
  }, [_vm._v("The principal of the school, Mr. Mal, stood in front of the podium. The auditorium fell silent, waiting for him to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e69410"
    }
  }, [_vm._v("“Students and faculty members, I am greatly honored to present Matthew, our leader. Please welcome him kindly.” The auditorium erupted into an overwhelming wave of cheers and applause. I sat there stiffly clenching my hands in my lap. He would get no applause from me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e71310"
    }
  }, [_vm._v("As Matthew approached the podium, I couldn’t help but feel rage boiling through my body. He was tall, over six feet, and had brown hair and stinging blue eyes. His right hand rose and the entire room fell silent. He rarely came to our school, although he had visited three times in the past two years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e73110"
    }
  }, [_vm._v("“Good afternoon,” Matthew said. There was another round of cheers. “This morning I just got word that we defeated a major part of Eleva—a Community not too far north from here—and other troops have started moving forward toward Jarva.” More applause resonated in the auditorium.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e74910"
    }
  }, [_vm._v("Matthew smiled. “But I’m really here to tell you that there will be tryouts for our next soldier recruits. Those of you eager to defend Tamizeh and take part in the Long War can apply for the positions regardless of age, but will have to pass very demanding examinations. I was given a list of some of the top students who will be taking part  in those tests. Please join me in congratulating the top five students: Miles Tord, Lexi Jay, Kimbal Restuart, Chester Limki, and . . . Alexia.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e78011"
    }
  }, [_vm._v("As soon as my name was mentioned, everyone stopped clapping. I swallowed a lump in my throat. All heads turned toward the back of the auditorium, searching for me. My cheeks burned. Murmured whispers flew throughout the room, and I felt myself shrinking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e79511"
    }
  }, [_vm._v("Matthew continued, “Starting this afternoon, those five students will be tested, and those interested who are not on the list are welcomed to join them. Simply sign up and speak with your teachers. Thank you. May Tamizeh only grow stronger.” Matthew finished and stepped away, but I could swear that he found me among the crowd. We stared at each other for a moment, my heart wrenching.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e81611"
    }
  }, [_vm._v("As the place cleared, I remained seated. I didn’t want to go to war. I hated the War. Had I known that my grades were going to be released and used to recruit me, I would have failed as many subjects as possible. My heart had dropped to my stomach and kept me glued to my chair. Not only did I stand out because of my physical traits, but Matthew had called me “Alexia” in front of the entire school. I didn’t have a last name. I didn’t know my parents and had been living with my foster family, Lyli and her parents, for about five years. Maybe I didn’t even have a last name.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e84711"
    }
  }, [_vm._v("“Congrats! I’m really proud of you!” Lyli said as she approached. “I’ll see you after your examination. I have a history test. Good luck.” She tapped me on the shoulder and ran off.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e85911"
    }
  }, [_vm._v("After a few minutes, I was the only person left in the auditorium. Mr. Mal startled me when he yelled across the stage, ordering me to go to the gym before I insulted Matthew and disgraced his school. I jumped to my feet and sprinted across campus.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e87411"
    }
  }, [_vm._v("A massive crowd had formed. I had to fight my way in, pushing people’s shoulders and getting rammed into the walls. An announcement shouted over everyone’s racket: “Alexia has two minutes  to get to the ring or is disqualified. Alexia has two minutes to get to the ring or is disqualified . . .” the statement repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e89612"
    }
  }, [_vm._v("Out of nowhere, someone grabbed my arm and pulled me into an open space. “You were at the top of the list! Get in there now!” one of the teachers scolded as she drove me through the wild throng, then pushed me onto a mat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e91112"
    }
  }, [_vm._v("Miles stood at the other side of the mat. He was the second tallest guy at our school, very built, and had a strong, threatening presence. He had changed into his martial arts uniform, while I was still in my jeans and t-shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e92812"
    }
  }, [_vm._v("“Take off your shoes, belt, and any jewelry that could harm your opponent,” one of the teachers said. I placed my belongings on the side of the mat, then made my way to the center, mirroring Miles. A bell rang, and the fight started.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e94312"
    }
  }, [_vm._v("I hated violence, but I was trained in martial arts and knew very well that if I didn’t defend myself or win, Miles would pulverize me. At first, I considered losing on purpose, but I couldn’t let him hurt me, and if I lost everyone would tease me. I decided to do my best and figure out how to avoid the recruitment afterward. Besides, those who lost could still be recruited depending on how the rest of the potential soldiers did. I’d rather be recruited and win than recruited and lose.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e97012"
    }
  }, [_vm._v("Without the slightest hint of hesitation, Miles side-kicked my temple, but I bent my knees and just barely avoided it. I spun around and threw a spinning kick to take out his legs, but he jumped over it. I rolled away from him and got back onto my feet. He was throwing combination strikes at the speed of light. I blocked a few, took another punch to the abdomen, then launched one fist to his head. He had to back away to catch his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e99612"
    }
  }, [_vm._v("Miles threw a kick, but I caught his foot and slammed him to the ground. I pinned him down and held my fist by his head to indicate that the fight was over. The bell rang again, and I let him go.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e101413"
    }
  }, [_vm._v("“I’m sorry, Miles,” I said as I offered a hand to help him up and apologized for any injuries. I felt like a monster. He had never done anything to me, and I had just released my fury onto him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e102513"
    }
  }, [_vm._v("“Alexia continues to the following round. Miles will take a seat for now . . .” The announcement started up the clamor again, and I felt my cheeks blush. I could never stand being the center of attention.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e103713"
    }
  }, [_vm._v("Similar fights continued until late that evening. By the time I was released, I hadn’t lost to a single opponent and only had a few mild bruises, but I wasn’t tired. To be honest, I was never tired. Mr. Mal congratulated me on my way out. I nodded at his compliments, but I really didn’t appreciate the admiration for fighting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e105513"
    }
  }, [_vm._v("I walked alone on the sidewalk to Lyli’s family—my host family. For the past five years, I have been living with Lyli and her parents. No matter how many times I asked about my parents, they would all just stare at me with empty glares, even Lyli. At least she would listen to my complaints and comfort me when I was alone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e107313"
    }
  }, [_vm._v("I didn’t know much about the adoption, and Lyli’s parents wouldn’t talk about it either. In fact, they practically never spoke to me. We just didn’t understand each other, and I think they were embarrassed to be associated with my black hair and violet eyes. In the beginning, I tried so hard to talk to them, but they would only nod and avoid eye contact. I gave up after a while. Sure, I yearned for a loving family, but I couldn’t make them love me, so what was the point of trying? I spent the majority of my time alone in my room or talking with Lyli.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e110113"
    }
  }, [_vm._v("As I thought about all the fighting, I started to feel infuriated. Not only had I hurt so many students, but they wanted to be soldiers and I didn’t. I wasn’t sure why I hadn’t lost the fights on purpose, but there was something that had driven me to win. The cool wind whipped at my cheeks as I walked home in shame.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticClass: "imgpub",
    attrs: {
      "alt": "9781937084318-txt_0013_001",
      "id": "d14e354",
      "src": "images/9781937084318-txt_0013_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e112614"
    }
  }, [_vm._v("“So how was it? I heard you did well,” Lyli said as she walked into my room and sat on my bed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e113414"
    }
  }, [_vm._v("“Some people like to exaggerate,” I responded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e113914"
    }
  }, [_vm._v("“Dinner will be ready soon. Come down in five minutes, okay?” She shut the door on her way out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e114814"
    }
  }, [_vm._v("I lay on my bed with all my limbs spread out, trying to relax and not touch any fresh bruises. The plump, purple bruise on my left shin looked like a ripe blackberry. It was really sensitive to the touch, but I had had numerous injuries before, and I knew it would almost be healed in the next twenty-four hours.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e116614"
    }
  }, [_vm._v("I slowly lugged myself down the stairs. We were one of the few houses that didn’t have elevators, but I didn’t mind. When I walked into the kitchen, Lyli motioned for me to sit at the dinner table. Her mom brought a warm, fragrant dish to the table while her father carried a pitcher of water. He dropped a small pellet into the pitcher to purify the liquid. Because of the War, the Community could no longer afford running, clean water to individual houses, so we all relied on filtering pills and used dry-cleansing showers. We ate in utter silence, like we usually did. As soon as I finished the casserole, I placed my plate in the instant dishwasher, turned it on, took it back out, and placed it back in the cupboard with the clean dishes. I then joined the family and waited to be dismissed to my room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e120614"
    }
  }, [_vm._v("Lyli’s parents called my name from time to time, but that was always the extent of our conversing. On the other hand, Lyli spent hours with them, sharing her stories of what had happened at school that day. I preferred my personal space, but I longed for some sense of belonging. To her parents, I practically didn’t exist. For my whole life, all fifteen years of it, I didn’t really exist to anyone.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06081e6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lodi_9781937084325_epub_c4_r1.vue
// module id = 69
// module chunks = 0